/**
 * Voxly — shared photo filter presets.
 *
 * Each filter is pure CSS so previews are instant and free.
 * Phase 55: tuned to feel dramatically stronger and more "social-media".
 * Added 4 cinematic looks: Teal&Orange, Filmic, Neon, Bleach Bypass.
 */

export const PHOTO_FILTERS = [
  { id: null, label: "Original", css: "none" },

  // Strong, social-media first impressions
  { id: "vivid", label: "Vivid", css: "saturate(1.95) contrast(1.18) brightness(1.05)" },
  { id: "punch", label: "Punch", css: "saturate(2.1) contrast(1.4) brightness(0.97)" },
  { id: "drama", label: "Drama", css: "contrast(1.55) saturate(1.25) brightness(0.85)" },
  { id: "fade", label: "Fade", css: "contrast(0.82) saturate(0.85) brightness(1.12)" },

  // Cinematic — Phase 55 new
  { id: "teal_orange", label: "Cinema", css: "saturate(1.4) contrast(1.25) brightness(1.02) hue-rotate(-8deg) sepia(0.18)" },
  { id: "filmic", label: "Filmic", css: "contrast(1.3) saturate(1.1) brightness(0.96) sepia(0.12)" },
  { id: "neon", label: "Neon", css: "saturate(2.4) contrast(1.45) brightness(1.05) hue-rotate(15deg)" },
  { id: "bleach", label: "Bleach", css: "saturate(0.4) contrast(1.6) brightness(1.1)" },

  // Mood & warmth
  { id: "warm", label: "Warm", css: "sepia(0.35) saturate(1.45) hue-rotate(-12deg) brightness(1.05)" },
  { id: "honey", label: "Honey", css: "sepia(0.55) saturate(1.55) hue-rotate(-20deg) brightness(1.1) contrast(1.08)" },
  { id: "ember", label: "Ember", css: "sepia(0.65) saturate(1.8) hue-rotate(-28deg) contrast(1.18) brightness(0.94)" },

  // Cool tones
  { id: "cool", label: "Cool", css: "saturate(1.2) hue-rotate(22deg) brightness(1.06) contrast(1.05)" },
  { id: "aqua", label: "Aqua", css: "saturate(1.5) hue-rotate(35deg) brightness(1.08) contrast(1.1)" },
  { id: "noir", label: "Noir", css: "grayscale(1) contrast(1.55) brightness(0.88)" },
  { id: "mono", label: "Mono", css: "grayscale(1) contrast(1.1) brightness(1.02)" },

  // Vintage
  { id: "sepia", label: "Sepia", css: "sepia(0.9) contrast(1.15) brightness(1.02)" },
  { id: "vintage", label: "Vintage", css: "sepia(0.5) saturate(1.2) contrast(0.9) brightness(0.94) hue-rotate(-6deg)" },
  { id: "lofi", label: "Lo-Fi", css: "contrast(1.65) saturate(1.7) brightness(0.92)" },

  // Soft / dreamy
  { id: "smooth", label: "Smooth", css: "saturate(0.9) blur(0.5px) brightness(1.1)" },
  { id: "dreamy", label: "Dreamy", css: "saturate(1.3) blur(0.7px) brightness(1.12) contrast(0.93)" },
];

// CSS mirror used by feed cards (StoriesRing / story viewer) so we don't re-render
// the same map twice. Keyed by filter id.
export const PHOTO_FILTER_CSS = Object.fromEntries(
  PHOTO_FILTERS.map((f) => [f.id || "none", f.css])
);
